import React from "react"
import cx from "classnames"
import styles from "./styles.module.scss"

interface Props {
	text: string
	link: string
	target?: string
	className?: string
}

const LinkButton:React.FC<Props> = ({text, link, target, className}) => {
	return (
		<a href={link} target={target} className={cx(styles.LinkButton, className)}>{text}</a>
	)
}

export default LinkButton